import Image from 'next/image'

type IconCoinProps = {
  width: number
  height: number
}

export const IconCoin = (props: IconCoinProps) => {
  const { width, height } = props
  return (
    <Image
      src={'/coin-detail.png'}
      width={width}
      height={height}
      alt="アバター画像"
      className="rounded-full"
    />
  )
}
